/* ng build --configuration dev */
/* ng build --prod */
/*src/environments/environment.dev.ts */
import { Location } from '@angular/common';

import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { ActivatedRoute, NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router } from '@angular/router';
import { alert } from 'devextreme/ui/dialog';
import { NgxSpinnerService } from "ngx-spinner";
import { Apiservice } from './services/api.service';
import { ComponentService } from './services/component.service';
import { RoutesService } from './services/routes.service';
import { ThemeService } from './services/theme.service';
import { Utenteservice } from './services/utente.service';






declare var $: any;
declare var _: any;
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],

  providers: [RoutesService]
})


export class AppComponent implements OnInit {
  title = 'WebRifiuti';
  tipoUtente: number;
  _opened: boolean = true;
  currentUrl: any;
  myTimeout: any

  @Output()
  customEvent: EventEmitter<any> = new EventEmitter<any>();
  socketLive: EventEmitter<any> = new EventEmitter<any>();


  _toggleSidebar() {
    this._opened = !this._opened;
  }
  constructor(
    private appService: Apiservice,
    private location: Location,
    private routeA: ActivatedRoute,
    private spinner: NgxSpinnerService,
    private router: Router,
    public utenteService: Utenteservice,
    private themeService: ThemeService,
    private userComponentService: ComponentService,


    /******/
  ) {


  }

  ngOnInit() {
    let dovesono = [];
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        dovesono = event.url.split("?");
        const cleanedUrl = dovesono[0].replace(/^\/main\//, '');
        console.log('🔄 Inizio navigazione:', cleanedUrl);

        // if (!this.canLeavePage) {
        //   // blocca navigazione e torna indietro
        //   this.location.back();
        // }



      }

      if (event instanceof NavigationEnd) {
        // console.log('✅ Navigazione completata:', event.url);
        // console.log('✅ Navigazione completata:', event);
        //dovesono=event.url.split("?");
        //const cleanedUrl = dovesono[0].replace(/^\/main\//, '');
        // console.log('✅ Navigazione completata:', cleanedUrl);
        // if(cleanedUrl=='registro-carico-e-scarico-rifiuti')
        //   this.location.back;// Non funziona 

      }

      if (event instanceof NavigationCancel) {
        // console.log('🚫 Navigazione annullata:', event.url);
      }

      if (event instanceof NavigationError) {
        // console.log('❌ Errore di navigazione:', event.error);
      }
    });




    /* addEventListener("beforeunload", (event) => {
       event.preventDefault();
       event.returnValue = true
     });
     window.onbeforeunload = function (e) {  
            e = e || window.event;  // IE Fix       
             if (e) { 
                        e.returnValue = 'Uscendo senza salvare perderai il tuo lavoro, vuoi continuare?';
                   }       
             return 'Uscendo senza salvare perderai il tuo lavoro, vuoi continuare?';   
          
     };
*/
    /*
     this.socketIoService.connect();
     this
     .socketIoService
     .on('diretta')
     .subscribe( (data: any) => {
       const liveStatus = {
         message:'diretta',
         is_live: data.is_live,
         title: data.title,
         link:""
       };
       this.customEvent.emit(liveStatus)
       this.socketLive.emit(liveStatus);        
       let msg:messagefromComponent=
       {
         codeMessage:89,
         traceMessage:'diretta',
         value :liveStatus
       }
     this.userComponentService.emitMessage(msg)
     });      
*/
    /* this.utenteService.UltimoAccesso.subscribe((value) => {
      //console.log("ULTIMO ACCESSO ",value);
      //this.myTimeout.refresh();  
      clearTimeout(this.myTimeout);  
      if(this.utenteService.checSessionError==true)
        this.myTimeout= setTimeout(this.timeSession, environment.TIME_SESSION*60*1000);

    }) */

    if (!localStorage.getItem('Filtri')) {


      localStorage.removeItem('emissioneFormulariFiltri');
      localStorage.removeItem('emissioneFomulariFiltri');
      localStorage.removeItem('stampaRegistriFiltri');
      localStorage.removeItem('movimentiRifiutoFiltri');

      localStorage.setItem('Filtri', JSON.stringify({}));
    }

    /*
    this.router.events.pipe(filter((event) => event instanceof NavigationError)
    ).subscribe((event: NavigationError) => {
      const root = this.router.routerState.snapshot.root;
      console.log('router' ,event.url)
      
      this.router.navigateByUrl('/main')
    })
    */

    let OBJ = sessionStorage.getItem('userrentrincloud');
    let OBJ1 = sessionStorage.getItem('EXAGERATOWEB');
    let OBJ2 = sessionStorage.getItem('EXAGERATOWEBTOKEN');

    if (OBJ) {
      this.utenteService.InfoUtenteConnesso = JSON.parse(OBJ);
      this.utenteService.AccessiExagerato.connesso = true;
      this.spinner.show();
      setTimeout(() => {
        this.spinner.hide();
        this.tipoUtente = this.utenteService.InfoUtenteConnesso.idtipoutente;//this.utenteService.InfoDatiUtenteConnesso.idtipoutente;            
        this.utenteService.SetetUserInfo(this.utenteService.InfoUtenteConnesso);
      }, 1000);

      //this.utenteService.changedUser.next(this.utenteService.InfoUtenteConnesso);
    }
    if (OBJ2) this.utenteService.TokenLoggato = JSON.parse(OBJ2);
    //this.utenteService.AccessiExagerato=JSON.parse(OBJ1);
    //console.log("Login IsAuthenticate"+this.utenteService.InfoUtenteConnesso.logIn);
    //this.utenteService.changedUser.next(this.utenteService.InfoUtenteConnesso);






    //let OBJ2=JSON.parse(sessionStorage.getItem('EXAGERATOWEBTOKEN'));      
    if (OBJ2) {
      // this.utenteService.SetToken(OBJ2.access_token);


      //this.utenteService.TokenLoggato=JSON.parse(OBJ2);
      //this.utenteService.changedUser.next(this.utenteService.InfoUtenteConnesso);
    }


    //this.utenteService.AccessiExagerato=JSON.parse(OBJ1);      
    try {
      //return JSON.parse(OBJ);
      //console.log("NGONINIT ",JSON.parse(OBJ));
    } catch (e) {
      //return "";
    }
    //this.tipoUtente = this.utenteService.InfoDatiUtenteConnesso.idtipoutente;      
    //this.menuRoutes = this.routesService.getRoutesOwner();
    //console.log("Ecco alla partenze ",this.route.url);

    this.themeService.applyTheme('softblue.compact');




  }

  timeSession() {
    alert("ATTENZIONE!!<br>La Sessione di lavoro sta per scadere", "Info Sessione");
  };





  isAuthenticated() {
    //this.utenteService.changedUser.next(this.utenteService.InfoUtenteConnesso);
    return this.utenteService.InfoUtenteConnesso.logIn;


    let OBJ = sessionStorage.getItem('userrentrincloud');
    let OBJ1 = sessionStorage.getItem('EXAGERATOWEB');
    let OBJ2 = sessionStorage.getItem('EXAGERATOWEBTOKEN');

    if (OBJ) this.utenteService.InfoUtenteConnesso = JSON.parse(OBJ);
    if (OBJ2) this.utenteService.TokenLoggato = JSON.parse(OBJ2);
    //this.utenteService.AccessiExagerato=JSON.parse(OBJ1);
    //console.log("Login IsAuthenticate"+this.utenteService.InfoUtenteConnesso.logIn);

    if (OBJ) {
      this.utenteService.changedUser.next(this.utenteService.InfoUtenteConnesso);
      return this.utenteService.InfoUtenteConnesso.logIn;
    } else return false;
  }

}
